import { render, staticRenderFns } from "./LLTagsInput.vue?vue&type=template&id=7dba23ca&scoped=true"
import script from "./LLTagsInput.vue?vue&type=script&lang=js"
export * from "./LLTagsInput.vue?vue&type=script&lang=js"
import style0 from "./LLTagsInput.vue?vue&type=style&index=0&id=7dba23ca&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7dba23ca",
  null
  
)

export default component.exports